import React, { Component } from "react";
import Logo from '../../Images/Logo.svg'
import Okay from '../../Images/okay.PNG'
import "./PaymentReceived.css";

export default class PaymentReceived extends Component{
    render(){
        const email = this.props.email || this.props.location?.state?.email || localStorage.getItem("pharmacy_email") || "";
        return(
            <div>
                <div className="payment">
                <div className="receive_msg"><img src={Logo} className="payment_logo" alt="Logo"></img></div>
                <div className="receive_msg"><img src={Okay} className="okay" alt="Success"></img></div>
                <div><h4 className="payment_received">Payment Received</h4></div>
                <div className="receive_msg">Thank you, your payment has been successful.</div>
                {email && (
                  <>
                    <div className="receive_msg">A confirmation email has been sent to</div>
                    <div className="receive_msg"><h4 className="email">{email}</h4></div>
                  </>
                )}
            </div>
            </div>
        )
    }
}
